import { Image } from '@buffer-mono/popcorn'
import styled from 'styled-components'

export const StyledImage = styled(Image)`
  min-height: 319px;
  background: var(--color-bg-subtle);
`
